// extracted by mini-css-extract-plugin
module.exports = {"mark-description":"MarkDescription_mark-description__9J5CK"};